"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

import { Button } from "@/components/ui/button"
export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  // useEffect only runs on the client, so now we can safely show the UI
  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-9 w-9 rounded-full opacity-0"
      >
        <Sun className="h-4 w-4" />
      </Button>
    )
  }

  const toggleTheme = () => {
    const current = resolvedTheme || theme
    if (current === "dark") {
      setTheme("light")
    } else {
      setTheme("dark")
    }
  }

  const currentIconTheme = resolvedTheme || theme

  return (
    <Button
      // Explicitly type="button". The underlying ui/Button sets no type, so it
      // inherits the HTML default of "submit" — and this toggle now renders on
      // the signed-out login and signup screens, which are the only pages in
      // the app built around a <form>. It sits outside those forms today, but
      // one reshuffle of the header markup would turn a theme flip into a
      // form submission. Cheap to pin, unpleasant to debug.
      type="button"
      variant="outline"
      size="icon"
      className="h-9 w-9 shrink-0 rounded-full"
      onClick={toggleTheme}
      title="Toggle theme"
    >
      {currentIconTheme === "dark" ? (
        <Sun className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <Moon className="h-[1.2rem] w-[1.2rem]" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
